import useClickOutside from "@/hooks/ClickOutsideHook";
import { useUserSession } from "@/UserSessionProvider";
import Link from "next/link";
import { useRouter } from "next/router";
import React, { useState } from "react";
import { FaWhatsapp } from "react-icons/fa";
import {
  LuArrowLeftRight,
  LuBriefcase,
  LuChevronDown,
  LuDatabase,
  LuList,
  LuLogOut,
  LuPlus,
  LuUser,
} from "react-icons/lu";

const ProfileButton = () => {
  const { user, setUser } = useUserSession();
  const [isOpen, setIsOpen] = useState(false);
  const router = useRouter();

  const handleClickOutside = () => {
    setIsOpen(false);
  };

  useClickOutside(handleClickOutside);

  const logout = () => {
    setUser(null);
    router.push("/sign-out");
  };

  const goToProfilePage = () => {
    window.location.href = "/agent-admin/account/business-profile";
  };

  const goToWhatsAppMessages = () => {
    window.location.href = "/app-admin/messages/whatsapp";
  };

  return (
    <>
      {user ? (
        <div className="relative " onClick={() => setIsOpen(!isOpen)}>
          <div className="flex items-center cursor-pointer ">
            <div className="flex items-center justify-center w-8 h-8 bg-[#1ED760] rounded-full cursor-pointer">
              <LuUser className="text-white" />
            </div>
            <div className="ml-2 w-[85px]">
              <div className="font-semibold text-white overflow-hidden whitespace-nowrap text-ellipsis">
                {user?.name}
              </div>
            </div>
            <LuChevronDown className="text-white" />
          </div>

          {isOpen && (
            <div>
              <div className=" absolute top-10 right-0 w-48 bg-white rounded shadow-lg overflow-hidden">
                {user.userType === "admin" && (
                  <>
                    <Link
                      href="/agent-admin"
                      className="p-4 flex space-x-2 items-center clickable cursor-pointer hover:bg-gray-100"
                    >
                      <LuDatabase />
                      <span>Dashboard</span>
                    </Link>
                    <div
                      className="p-4 flex space-x-2 items-center clickable cursor-pointer hover:bg-gray-100"
                      onClick={() => {
                        goToWhatsAppMessages();
                      }}
                    >
                      <FaWhatsapp />
                      <span>WhatsApp Messages</span>
                    </div>
                  </>
                )}
                <Link
                  href="/agent-admin/post"
                  className="p-4 flex space-x-2 items-center clickable cursor-pointer hover:bg-gray-100"
                >
                  <LuPlus />
                  <span>Create Post</span>
                </Link>
                <div
                  className="p-4 flex space-x-2 items-center clickable cursor-pointer hover:bg-gray-100"
                  onClick={() => {
                    router.push("/agent-admin/listings");
                  }}
                >
                  <LuList />
                  <span>My Posts</span>
                </div>
                <div
                  className="p-4 flex space-x-2 items-center clickable cursor-pointer hover:bg-gray-100"
                  onClick={() => {
                    goToProfilePage();
                  }}
                >
                  <LuBriefcase />
                  <span>My Business Profile</span>
                </div>

                {user.hasMultipleAccounts && (
                  <div
                    className="p-4 flex space-x-2 items-center clickable cursor-pointer hover:bg-gray-100"
                    onClick={() => {
                      router.push("/agent-admin/account/select?fp=1");
                    }}
                  >
                    <LuArrowLeftRight />
                    <span>Switch Account</span>
                  </div>
                )}
                <div
                  className="p-4 flex space-x-2 items-center text-red-500 clickable cursor-pointer hover:bg-gray-100"
                  onClick={() => {
                    logout();
                  }}
                >
                  <LuLogOut />
                  <span>Logout</span>
                </div>
              </div>
            </div>
          )}
        </div>
      ) : (
        <div className="flex">
          <div className="ml-2">
            <Link href={"/sign-in"} className="font-semibold text-white">
              Login/Register
            </Link>
          </div>
        </div>
      )}
    </>
  );
};

export default ProfileButton;
